<script lang="ts">
  import type { Snippet } from 'svelte';

  import LoginCardHeader from './LoginCardHeader.svelte';

  let { children, customerLogo }: { children: Snippet; customerLogo?: string } = $props();
</script>

<div
  class="flex min-h-[528px] w-[540px] flex-col gap-6 rounded-md bg-white px-6 pb-12 pt-6 shadow-card"
>
  <LoginCardHeader {customerLogo}></LoginCardHeader>
  <div class="flex flex-1 flex-col items-center justify-start gap-8">
    {@render children()}
  </div>
</div>
